module.exports = __webpack_public_path__ + "static/img/1.2762bdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/1.png
// module id = 9P3U
// module chunks = 0